module.exports = __webpack_public_path__ + "img/pricing-img.f3921f31.svg";